import React from "react";
import ClosePayable from "../../../common/poppers/ClosePayable";
import DeleteObject from "../../../common/poppers/DeleteObject";
import PayableDetail from "../../../common/poppers/details/PayableDetail";
import GroupForPayable from "../../../common/poppers/GroupForPayable";
import ManualMatcherForPayable from "../../../common/poppers/ManualMatcherForPayable";
import Matcher from "../../../common/poppers/MatcherForPayable";
import RemovePayableFromGroup from "../../../common/poppers/RemovePayableFromGroup";
import ModifyOutgoing from "./ModifyOutgoing";
import OutgoingBillRow from "./OutgoingBillRow";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import FilterListIcon from "@material-ui/icons/FilterList";

export const outgoingBillActionItems = [
  {
    className: "modify-row",
    dataDialog: "modify-dialog",
    title: "Módosít",
    dialogTitle: "Számla módosítása",
    canShow: (row) => "RECEIVED" !== row.state,
    icon: <EditIcon fontSize="small" color="primary" />,
    actionComponent: (props, close) => (
      <ModifyOutgoing {...props} close={close} />
    ),
  },
  {
    className: "accept-import-row",
    dataDialog: "receive-dialog",
    title: "Befogad",
    dialogTitle: "Számla befogadása",
    icon: <EditIcon fontSize="small" color="primary" />,
    canShow: (row) => "RECEIVED" === row.state,
    actionComponent: (props, close) => (
      <ModifyOutgoing {...props} close={close} />
    ),
  },
  {
    className: "close-row",
    dataDialog: "close-dialog",
    title: "Lezárás",
    dialogTitle: "Számla Lezárása",
    canShow: (row) =>
      "PAID" !== row.state &&
      "CLOSED" !== row.state &&
      "RECEIVED" !== row.state,
    actionComponent: (props, close) => (
      <ClosePayable
        {...props}
        close={close}
        path={"/api/manualclose/payable"}
        isClose={true}
        confirm={"Biztos hogy le szeretnéd zárni?"}
        comp={<OutgoingBillRow {...props} />}
      />
    ),
  },
  {
    className: "reopen-row",
    dataDialog: "close-dialog",
    title: "Újranyitás",
    dialogTitle: "Számla Újranyitása",
    canShow: (row) => "CLOSED" === row.state && "RECEIVED" !== row.state,
    actionComponent: (props, close) => (
      <ClosePayable
        {...props}
        close={close}
        path={"/api/manualclose/payable"}
        isClose={false}
        confirm={"Biztos hogy újra szeretnéd nyitni?"}
        comp={<OutgoingBillRow {...props} />}
      />
    ),
  },
  {
    className: "details-row",
    dataDialog: "detail-dialog",
    title: "Részletek",
    dialogTitle: "Részletek",
    width: "lg",
    icon: <FilterListIcon fontSize="small" color="primary" />,
    actionComponent: (props, close) => (
      <PayableDetail
        {...props}
        close={close}
        row={props.row}
        billtype={props.tabletype}
      />
    ),
  },
  {
    divider: true,
  },
  {
    className: "transaction-auto-link-row",
    dataDialog: "transaction-dialog",
    title: "Tranzakció linkel",
    dialogTitle: "Linkel",
    canShow: (row) => "MATCH_FOUND" === row.state,
    actionComponent: (props, close) => (
      <Matcher
        {...props}
        close={close}
        row={props.row}
        billtype={props.tabletype}
      />
    ),
  },
  {
    className: "transaction-manual-link-row",
    dataDialog: "transaction-dialog",
    title: "Manuális linkel",
    dialogTitle: "Manuális linkel",
    width: "lg",
    canShow: (row) => "NEW" === row.state || "INCOMPLETE" === row.state,
    actionComponent: (props, close) => (
      <ManualMatcherForPayable
        {...props}
        close={close}
        row={props.row}
        billtype={props.tabletype}
      />
    ),
  },
  {
    className: "invoice-link-row",
    dataDialog: "group-dialog",
    title: "Számla linkel",
    dialogTitle: "Számla linkel",
    canShow: (row) =>
      "PAID" !== row.state &&
      "CLOSED" !== row.state &&
      "RECEIVED" !== row.state &&
      !row.groupPublicId,
    actionComponent: (props, close) => (
      <GroupForPayable
        {...props}
        close={close}
        row={props.row}
        billtype={props.tabletype}
      />
    ),
  },
  {
    className: "delete-from-group-row",
    dataDialog: "remove-group-dialog",
    title: "Csoportból eltávolít",
    dialogTitle: "Csoportból eltávolít",
    canShow: (row) => row.groupPublicId,
    actionComponent: (props, close) => (
      <RemovePayableFromGroup
        {...props}
        close={close}
        row={props.row}
        billtype={props.tabletype}
      />
    ),
  },
  {
    divider: true,
  },
  {
    className: "delete-row",
    dataDialog: "delete-dialog",
    title: "Törlés",
    dialogTitle: "Számla törlése",
    canShow: (row) => "RECEIVED" !== row.state,
    icon: <DeleteIcon fontSize="small" color="primary" />,
    actionComponent: (props, close) => (
      <DeleteObject
        {...props}
        close={close}
        path={"/api/outgoingbill"}
        confirm={"Biztos hogy törölni szeretnéd?"}
        comp={<OutgoingBillRow {...props} />}
      />
    ),
  },
];
